const SIZE_CLASSES = {
    sm: 'py-2 px-4 text-sm rounded-md min-h-[44px]',
    md: 'py-2.5 px-4 text-sm rounded-lg min-h-[44px] w-full',
    lg: 'py-3 px-5 mt-5 w-full rounded-lg shadow-sm',
}

export const Button = ({
    className,
    label,
    disabled,
    variant = 'primary',     // 'primary' | 'outline'
    size = 'lg',             // see SIZE_CLASSES above; an unknown size falls back to 'lg'
    onClick = () => {}
}) => {
    // Hover styles only apply while enabled: a disabled button must not look clickable.
    const base = 'border focus:ring-2 focus:ring-offset-2 focus:outline-none focus:ring-blue-600 disabled:opacity-50 disabled:cursor-not-allowed'
    const sizeClasses = Object.prototype.hasOwnProperty.call(SIZE_CLASSES, size) ? SIZE_CLASSES[size] : SIZE_CLASSES.lg
    const variantClasses = variant === 'outline'
        ? 'border-blue-500 text-blue-600 bg-white enabled:hover:bg-blue-50'
        : 'border-transparent bg-blue-500 text-white enabled:hover:bg-blue-600'
    return (
        <button
            type="button"
            className={`${base} ${sizeClasses} ${variantClasses} ${className || ''}`.trim()}
            disabled={disabled}
            onClick={onClick}
        >
            {label}
        </button>
    )
}
